module.exports = __webpack_public_path__ + "fd6d81b7e3d6578eeb67e3c8fc77e33e.jpg";